import { useQuery } from '@tanstack/react-query';
import { getAdvisory } from './api';

/** Fetches advisory detail for a CVE/GHSA id. */
export function useAdvisory(id: string | undefined) {
  return useQuery({
    queryKey: ['advisory', id],
    queryFn: () => getAdvisory(id!),
    enabled: Boolean(id),
  });
}
